//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  methods: {
    useMoment(testimonialDate) {
      if (testimonialDate != "") {
        return this.$moment(testimonialDate).format("MMM DD, YYYY");
      }
    },
  },
};
